import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
interface Section {
  title: string;
  body: React.ReactNode;
}
const sections: Section[] = [{
  title: '1. Producto',
  body: <p data-id="element-236">
        El presente documento regula las condiciones de uso y adquisición del
        e-book digital{' '}
        <strong className="text-brand-charcoal" data-id="element-237">
          "Resetea tu Cortisol en 21 Días"
        </strong>
        , ofrecido por{' '}
        <strong className="text-brand-charcoal" data-id="element-238">El Código del Bienestar</strong>{' '}
        a través de este sitio web.
      </p>
}, {
  title: '2. Naturaleza del producto',
  body: <p data-id="element-239">
        El producto es un{' '}
        <strong className="text-brand-charcoal" data-id="element-240">
          producto digital de descarga inmediata
        </strong>
        , no físico. Una vez procesada la compra, el usuario recibirá el
        contenido en formato PDF a través del correo electrónico proporcionado.
      </p>
}, {
  title: '3. Entrega',
  body: <p data-id="element-241">
        La entrega es{' '}
        <strong className="text-brand-charcoal" data-id="element-242">
          inmediata tras la confirmación del pago
        </strong>
        . El enlace de descarga se envía al correo electrónico registrado en el
        momento de la compra. No existen tiempos de envío físico ni costos
        adicionales de logística.
      </p>
}, {
  title: '4. Política de reembolso',
  body: <p data-id="element-243">
        Por tratarse de un{' '}
        <strong className="text-brand-charcoal" data-id="element-244">
          producto digital de entrega inmediata
        </strong>
        , no se aceptan devoluciones ni reembolsos una vez completada la compra,{' '}
        <strong className="text-brand-charcoal" data-id="element-245">
          salvo en caso de error técnico comprobado
        </strong>{' '}
        que impida la entrega del producto. En esos casos, contáctanos para
        resolver la incidencia.
      </p>
}, {
  title: '5. Propiedad intelectual',
  body: <p data-id="element-246">
        Todo el contenido del e-book, incluyendo textos, imágenes, diseño y
        estructura, es{' '}
        <strong className="text-brand-charcoal" data-id="element-247">
          propiedad exclusiva de El Código del Bienestar
        </strong>{' '}
        y se encuentra protegido por las leyes de propiedad intelectual
        aplicables. Queda prohibida su reproducción, total o parcial, sin
        autorización previa y por escrito.
      </p>
}, {
  title: '6. Uso permitido',
  body: <>
        <p className="mb-4" data-id="element-248">
          El e-book está destinado a{' '}
          <strong className="text-brand-charcoal" data-id="element-249">
            uso personal únicamente
          </strong>
          . Al adquirirlo, el usuario se compromete a no:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-250">
          <li data-id="element-251">
            Revender, redistribuir o compartir el contenido en plataformas
            públicas o privadas.
          </li>
          <li data-id="element-252">Modificar, traducir o crear obras derivadas sin autorización.</li>
          <li data-id="element-253">Utilizar el material con fines comerciales de cualquier tipo.</li>
        </ul>
      </>
}, {
  title: '7. Limitación de responsabilidad',
  body: <p data-id="element-254">
        El contenido del e-book es de{' '}
        <strong className="text-brand-charcoal" data-id="element-255">
          carácter informativo y educativo
        </strong>{' '}
        y{' '}
        <strong className="text-brand-charcoal" data-id="element-256">
          no reemplaza el consejo, diagnóstico o tratamiento médico profesional
        </strong>
        . Antes de aplicar cualquier recomendación, consulta a un profesional de
        la salud, especialmente si tienes condiciones médicas preexistentes.
      </p>
}, {
  title: '8. Ley aplicable',
  body: <p data-id="element-257">
        Los presentes términos se rigen por la{' '}
        <strong className="text-brand-charcoal" data-id="element-258">legislación vigente</strong>{' '}
        aplicable. Cualquier controversia derivada del uso del sitio o del
        producto se resolverá conforme a la normativa correspondiente.
      </p>
}, {
  title: '9. Vigencia',
  body: <p data-id="element-259">
        Los presentes términos son{' '}
        <strong className="text-brand-charcoal" data-id="element-260">efectivos desde 2026</strong> y
        podrán ser actualizados en cualquier momento. Te recomendamos revisarlos
        periódicamente para conocer su versión más reciente.
      </p>
}];
export const Terms: React.FC = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, []);
  return <div className="min-h-screen bg-brand-offwhite font-sans text-brand-charcoal selection:bg-brand-mint selection:text-brand-charcoal flex flex-col" data-id="element-261">
      <Navbar data-id="element-262" />

      <main className="flex-1" data-id="element-263">
        {/* Header */}
        <section className="bg-brand-lightmint py-16 lg:py-20" data-id="element-264">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-266">
              <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-brand-emerald hover:text-brand-emeraldHover transition-colors mb-6" data-id="element-267">
                <ArrowLeft className="w-4 h-4" data-id="element-268" />
                Volver al inicio
              </Link>

              <div className="flex items-center gap-3 mb-4" data-id="element-269">
                <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-sm" data-id="element-270">
                  <FileText className="w-6 h-6 text-brand-emerald" data-id="element-271" />
                </div>
                <span className="text-sm font-medium uppercase tracking-wider text-brand-emerald" data-id="element-272">
                  Documento legal
                </span>
              </div>

              <h1 className="text-4xl md:text-5xl font-serif font-bold text-brand-charcoal leading-tight mb-4" data-id="element-273">
                Términos y Condiciones
              </h1>
              <p className="text-lg text-gray-600" data-id="element-274">
                Condiciones de uso y compra del e-book "Resetea tu Cortisol en
                21 Días" de El Código del Bienestar.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 lg:py-20" data-id="element-275">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
            <div className="space-y-10" data-id="element-277">
              {sections.map((section, index) => <motion.article key={section.title} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} data-id="element-278">
                  <h2 className="text-xl md:text-2xl font-serif font-bold text-brand-emerald mb-4" data-id="element-279">
                    {section.title}
                  </h2>
                  <div className="text-gray-700 leading-relaxed text-base" data-id="element-280">
                    {section.body}
                  </div>
                </motion.article>)}
            </div>

            <div className="mt-12 text-center" data-id="element-281">
              <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-full shadow-sm hover:shadow-md transition-all" data-id="element-282">
                <ArrowLeft className="w-4 h-4" data-id="element-283" />
                Volver al inicio
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-284" />
    </div>;
};